var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CCardBody',[_c('CDataTable',{attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"items":_vm.items,"fields":_vm.fields,"items-per-page":_vm.small ? 10 : 5,"dark":_vm.dark,"pagination":""},scopedSlots:_vm._u([{key:"status",fn:function(ref){
var item = ref.item;
return [_c('td')]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }